<template lang="pug">
  .profile-page__main
    .profile-page__body
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Текстовое описание
        .profile-section__body
          .form
            .form__elem.form__elem_full
              manager-shift-editor-copy-form-data(
              v-if="otherShifts.length > 0"
              :options="otherShifts"
              :current-data="fields"
              :current-shift="shiftData"
              @update-field="updateField"
              @cancel-update-field="cancelUpdateField"
              )
            .form__elem.form__elem_full
              .form-elem
                .form-elem__body
                  vue-editor.custom-editor(
                    :editorToolbar="customToolbar"
                    v-model="fields.program"
                  )
                  //textarea.textarea.textarea_full.manager-camp__camp-desc(
                  //v-model="fields.program"
                  //)
      section.profile-page-form__section.profile-section
        .profile-section__body
          .form
            .form__elem.form__elem_button
              .form-elem
                .form-elem__body
                  button.button.button_paint-main.button_long(
                  @click.prevent="onSaveCamp()"
                  )
                    .button__text Сохранить
                .form-elem__error(
                v-if="currentErrorMessage.length > 0"
                ) {{currentErrorMessage}}

</template>

<script>
import ManagerShiftEditorCopyFormData from "./components/ManagerShiftEditorCopyFormData";
import {VueEditor} from "vue2-editor";
export default {
  name: "ManagerShiftEditorProgram",
  components: {ManagerShiftEditorCopyFormData, VueEditor},
  props: {
    currentErrorMessage: {
      type: String,
      default: ""
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    shiftData: {
      type: Object,
      default: () => ({})
    },
    otherShifts: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      customToolbar: [
        [{size: ["small", false, "large", "huge"]}],
        ["bold", "italic", "underline"],
        [{list: "ordered"}, {list: "bullet"}],
        [
          {align: ""},
          {align: "center"},
          {align: "right"},
          {align: "justify"}
        ],
        ["link"]

      ],
      fields: {
        program: ""
      }
    };
  },
  methods: {
    setFields(data) {
      this.fields.program = data.program.text;
    },
    onSaveCamp() {
      const data = {
        program: {
          text: this.fields.program
        }
      };
      this.$emit("on-save-shift", data);
    },
    updateField(data) {
      this.setFields(data);
    },
    cancelUpdateField(data) {
      for (const key in data) {
        this.fields[key] = data[key];
      }
    }
  },
  watch: {
    shiftData(val) {
      this.setFields(val);
    }
  },
  mounted() {
    if (this.shiftData) {
      this.setFields(this.shiftData);
    }
  }
};
</script>
